export const BraspagScheduleModel = {
  getBraspagSchedule: (params, page) => {
    const {
      initialDate,
      finalDate,
      brand
    } = params

    const safeInitialDate = initialDate instanceof Date ? initialDate.toISOString().split('T')[0] : initialDate
    const safeFinalDate = finalDate instanceof Date ? finalDate.toISOString().split('T')[0] : finalDate

    return {
      initial_forecasted_date: safeInitialDate,
      final_forecasted_date: safeFinalDate,
      page_index: page || 1,
      brand: brand || undefined
    }
  }
}
